import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';

document.querySelectorAll('[data-acc02-gallery]').forEach(function (wrap) {
  var mainEl = wrap.querySelector('.acc02-10__gallery-main');
  var thumbsEl = wrap.querySelector('.acc02-10__gallery-thumbs');
  if (!mainEl || !thumbsEl) return;

  var thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    watchSlidesProgress: true,
    freeMode: true,
    breakpoints: {
      1025: { spaceBetween: 16 }
    }
  });

  var mainSwiper = new Swiper(mainEl, {
    loop: true,
    initialSlide: 0,
    spaceBetween: 0,
    thumbs: { swiper: thumbsSwiper }
  });

  mainSwiper.slideToLoop(0, 0);
});
